// Vanilla CSS for the divider primitives (DividerLine, VerticalDividerLine,
// BlueVerticalDividerLine). Prefix: dvl-. Aggregated into libraryStyles.
export const dividerStyles = `
  .dvl-h {
    background-color: var(--catchup-gray-50);
    height: 1px;
    width: 100%;
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
  }
  .dvl-v {
    background-color: var(--catchup-gray-50);
    height: 100%;
    width: 1px;
    margin-left: 0.75rem;
    margin-right: 0.75rem;
  }
  .dvl-blue {
    width: 2px;
    height: 40px;
    margin-top: 1rem;
    margin-bottom: 1rem;
    background-color: var(--catchup-blue);
  }
  .dvl-blue-medium { opacity: 0.5; }
`;
